export default __webpack_public_path__ + "static/media/password_new.3291708b.svg";